
<div
    style    = "margin-left: 75px;"
    :style   = "showTitle ? ' width: calc(100% - 75px)' : ''"
    v-resize = "onResize"
    @dragover.prevent
    @drop.prevent
>
    <d-inbox-customer
        v-model      = "editCustomer"
        :customer-id = "customerId"
    />

    <d-inbox-detail
        v-model     = "zoom"
        :attachment = "attachment.data"
        :height     = "height+70"
        @close      = "onClose"
        @morph      = "onMorph"
        @changed    = "onDChanged"
        @context    = "onDContext"
        @create     = "onCreate"
        @creategoto = "onCreateAndGoto"
    />

    <d-import-confirm
        v-model     = "confirm.show"
        :messages   = "confirm.messages"
        :files      = "confirm.files"
        @uploaded   = "onForceUploaded"
    />

    <d-upload-type-select
        v-model   = "typeSelect.show"
        :files    = "typeSelect.files"
        @confirm  = "onTypeConfirmed"
        @cancel   = "onTypeCancelled"
    />

    <c-app-bar
        v-if           = "showTitle"
        title          = "INBOX"
        :categories    = "[]"
        :enable-search = "false"
    >
        <template slot="search">
            <c-toolbar-button
                icon     = "mdi-home"
                color    = "primary"
                :size    = "22"
                :tooltip = "$t('home.button')"
                class    = "ml-2"
                @click   = "onLiftmanagement"
            />
            <v-spacer />
        </template>
    </c-app-bar>

    <c-customer-index
        :minimize           = "false"
        :enable-search      = "true"
        :filter-height      = "175"
        :pre-index-height   = "34"
        :show-misc          = "false"
        :show-unref-filter  = "false"
        :show-tags          = "false"
        @changed            = "onCustomer"
        ref                 = "index"
        :style              = "showTitle ? 'padding-right: 75px;' : ''"
    >
        <template v-slot:flags="{ item }">
            <div style="margin-top: -4px;" class="pr-1" v-if="customerId === item.id">
                <c-toolbar-button
                    color    = "primary"
                    size     = "24"
                    icon     = "mdi-pencil-box-outline"
                    :tooltip = "$t('inb.overview.customer.edit')"
                    @click   = "onEditCustomer(item)"
                />
            </div>
            <c-inbox-quality :item = "item" />
        </template>

        <template v-slot:pre-index>
            <v-row
                dense
                class  = "primary-border pl-2 mt-1 mb-1 v-flex"
                :class = "customerId === 'all' ? 'unknown-selected' : ''"
                style  = "margin-right: 14px!important; height: 30px; padding-top: 3px; border-radius: 4px;"
            >
                <a
                    @click="onAll"
                    class="w-100"
                >
                    <div class="v-flex">
                        <div>
                            {{ $t('inb.overview.customer.all') }}
                        </div>
                        <v-spacer />
                        <c-inbox-quality :all-mode="true" />
                    </div>
                </a>
            </v-row>
            <v-row
                dense
                class  = "primary-border pl-2 mt-1 mb-3 v-flex"
                :class = "customerId === 0 ? 'unknown-selected' : ''"
                style  = "margin-right: 14px!important; height: 30px; padding-top: 3px; border-radius: 4px;"
            >
                <a
                    @click="onUnknown"
                    class="w-100"
                >
                    <div class="v-flex">
                        <div>
                            {{ $t('inb.overview.customer.without') }}
                        </div>
                        <v-spacer />
                        <c-inbox-quality :item = "null" />
                    </div>
                </a>
            </v-row>
        </template>

        <template v-slot:detail="{  }">
            <div
                @drop      = "onDrop"
                @dragleave = "fileDragOut"
                @dragover  = "fileDragIn"
                class      = "w-100 h-100"
                :class     = "drag ? 'drop-allowed' : ''"
            >
                <div
                    v-if  = "customerId || customerId === 0"
                    class = "v-flex"
                >
                    <div style="width: 33.3%;">
                        <c-inbox-filter
                            @expand   = "onFilterExpanded"
                            @changed  = "onFilter"
                            @reload   = "onReload"
                            :text     = "search"
                            :messages = "data"
                            :all-mode = "customerId === 'all'"
                            ref       = "filter"
                        />

                        <div class=""
                            :style="'max-height: ' + scrollHeight + 'px; ' + 'height: ' + scrollHeight + 'px'"
                        >
                            <virtual-scroller
                                ref        = 'scroller'
                                :items     = "filteredMessages"
                                key-field  = "id"
                                :prerender = "2"
                                :style     = "'max-height: ' + scrollHeight + 'px; ' + 'height: ' + scrollHeight + 'px'"
                                style      = "width: calc(100% + 0px); overflow-y: scroll"
                            >
                                <div slot-scope="{ item }">
                                    <c-import
                                        :item     = "item"
                                        :selected = "attachment.data"
                                        class     = "import-card"
                                        @selected = "onSelected"
                                    />
                                </div>
                            </virtual-scroller>
                        </div>
                    </div>
                    <div class="ml-1 mt-0 pl-4 message-block"
                         :style = "panelHeight"
                    >
                        <div style="position: absolute; right: 1px; top: 15px; z-index: 10">
                            <c-inbox-attachment-menu
                                :attachment = "attachment.data"
                                :save-allowed = "tab === 1"
                                @save       = "onSave"
                                @ignore     = "onIgnore"
                                @confirmed  = "onConfirmend"
                                @refresh    = "onRefreshAttachment"
                                @zoom       = "onZoom"
                                @close      = "onClose"
                                @create     = "onCreate"
                                @creategoto = "onCreateAndGoto"
                            />
                        </div>

                        <div 
                            v-if="!attachment.data"
                            class="drop-zone-hint"
                        >
                            <div class="drop-zone-content">
                                <v-icon size="80" color="grey lighten-1">mdi-cloud-upload-outline</v-icon>
                                <div class="mt-4 text-h6 grey--text text--darken-1">
                                    {{ $t('inb.upload.hint') }}
                                </div>
                                <div class="mt-2 grey--text">
                                    {{ $t('inb.upload.subtitle') }}
                                </div>
                            </div>
                        </div>

                        <v-tabs
                            v-if="attachment.data"
                            v-model      = "tab"
                            class        = "mt-3 folder-tabs ml-0 mr-0 pr-0"
                            active-class = "folder-tab-active primary"
                            height       = "30"
                            style        = "height: calc(100% - 20px)"
                            light
                        >
                            <v-tabs-slider color="primary"></v-tabs-slider>
                            <v-tab
                                class="folder-tab"
                                :key="1"
                            >
                                Mail / Anhang
                            </v-tab>
                            <v-tab
                                class="folder-tab"
                                :key="2"
                            >
                                Inhalt
                            </v-tab>

                            <v-tabs-items
                                v-model="tab"
                                class="mt-1"
                                style="height: calc(100% - 40px);"
                                active-class="xxx"
                            >
                                <v-tab-item :key="1" style="height: 100%">
                                    <c-dms-viewer
                                        :document = "attachment.data.dmsId"
                                    />
                                </v-tab-item>

                                <v-tab-item :key="2" class="h-100">
                                    <c-inbox-detail
                                        :attachment = "attachment.data"
                                        @context    = "onContext"
                                        @changed    = "onChanged"
                                        @morph      = "onMorph"
                                        :height     = "height"
                                        ref         = "message"
                                        :key        = "refreshDetail"
                                    />
                                </v-tab-item>
                            </v-tabs-items>
                        </v-tabs>
                    </div>
                </div>
            </div>
        </template>
    </c-customer-index>
</div>
